
<style lang='scss' scoped>
</style>

<template>
	<div class="clearfix">
		<Breadcrumb class="tablelist-header">
			<BreadcrumbItem to="/">{{type==='edit'?$t('global.common.edit',{defaultValue:'编辑'}):$t('erp.product.new_add',{defaultValue:'添加'})}}{{$t('erp.stock.menu',{defaultValue:'分配模板'})}}</BreadcrumbItem>
		</Breadcrumb>
        <Alert class="padding-10">
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
		</Alert>
		<div class="bg-fff shadow padding-bottom-15" >
			<header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
			<Form :label-width="120" ref="form" class="splitline padding-right-15" :model='formData' style='max-width:600px'>
				<FormItem  prop="ruleName" :label="$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})" :rules="required">
					<vInput :value="formData.ruleName" readonly :placeholder="$t('erp.virtualstore.choosewarehouse',{defaultValue:'可点击搜索选择虚拟仓'})">
						<vButton slot="append" @click="showVirtual=true">{{$t('global.common.search',{defaultValue:'搜索'})}}</vButton>
					</vInput>
				</FormItem>
				<FormItem prop="templateName" :label="$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'})" :rules="required">
					<Input v-model="formData.templateName"></Input>
				</FormItem>
				<FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
					<span>{{getLineName(formData.lineId)}}</span>
				</FormItem>
				<FormItem label='ERP SKU'  v-if="type!=='edit'">
					<span v-if="formData.erpSkuReadonly">{{formData.erpSku}}</span>
					<Input v-else v-model="formData.erpSku"/>
					<p class="color-error" v-if="type!=='edit'">{{$t('erp.virtualstore.editskutip1',{defaultValue:'不选ERP SKU则表示：项目下所有ERP SKU都应用该分配模板（除单独设置一层分配的ERP SKU）'})}}<br>{{$t('erp.virtualstore.editskutip2',{defaultValue:'选择ERP SKU则表示：只有该ERP SKU应用此分配模板'})}}</p>
				</FormItem>
				<FormItem label='ERP SKU' v-else>
					<span>{{formData.erpSku}}</span>
				</FormItem>
				<FormItem :label="$t('erp.virtualstore.description',{defaultValue:'模板描述'})">
					<Input v-model="formData.description" type='textarea'></Input>
				</FormItem>
			</Form>
			<header class="detail-title">{{$t('erp.virtualstore.distributionnews',{defaultValue:'分配信息'})}}</header>
			<Table
			class="margin-10"
			:columns="columns"
			:data="formAllot"
			size="small"
			ref="table"
			border
			stripe
			:rules="required">
			<footer slot="footer" class="clearfix">
				<span style="width:330px;" class="pull-left padding-left-20">{{$t('erp.b2c.product_totalcount',{defaultValue:'总计'})}}</span>
				<span class="pull-left">{{assignPercentTotal}}</span>
			</footer>
			</Table>
			<footer class="text-center">
				<Button type="primary" @click="submit" class="width-15per">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
				<Button @click="cancel" class="width-15per">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
			</footer>
		</div>
		<!-- 虚拟仓 -->
		 <Modal
			width="1000"
			:title="$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})"
			@on-cancel="showVirtual=false"
			@on-ok="getvsData"
			v-model="showVirtual">
			<compVirtualdata ref="vsdata"/>
			<!-- <footer slot="footer" v-show="false"></footer> -->
			<!-- <footer slot="footer" >
				<Button type="primary" @click="getvsData"></Button>
				<Button @click="showVirtual=false">取消</Button>
			</footer> -->
		</Modal>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import { FormItem, InputNumber } from 'view-design'
import { HttpVsGroups } from '@/service/boss/dictionary'
import {
	HttpUpdateSaTemplate,
	HttpSaTemplate
} from '@/service/boss/allot';
import compVirtualdata from './virtualdata/index'

export default {
	components: {
		compVirtualdata
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			showVirtual: false,
			assignPercentTotal: 0,
			// vsrulelist: [],
			formData: {
				stockVirtualGroupRuleId: "",
				templateName: "",
				description: "",
				lineId: "",
				isDms: "0",
                erpSku: "",
                ruleName:"",
			},
			formAllot: [],
			required: [{
				required: true,
				message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'}),
				trigger: 'blur'
			}],
			requiredNUmver: [{
				required: true,
				message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'}),
				trigger: 'blur',
				type: "number",
			}],
			judge:false,
		};
	},
	created() {
		this.getDetail();
		// if (this.type !== 'edit') {
		// 	this.getVslist();
		// }
		this.$on('on-total', this.getTotal)
	},

	computed: {
		...mapGetters('diction',['getNewDifferentAllProductList']),
		columns() {
			return [
			{
				title: this.$t('global.common.channel',{defaultValue:'店铺'}),
				key: 'accountFlag',
				width: 300,
			}, 
			{
				title: this.$t('erp.virtualstore.assignPercent',{defaultValue:'分配比例'}),
				// key: 'assignPercent',
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'assignPercent', row, index, { min: 0 });
				}
			}, 
			{
				title: this.$t('erp.virtualstore.adjustValue',{defaultValue:'调整值'}),
				// key: 'adjustValue',
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'adjustValue', row, index);
				}
			}, 
			{
				title: this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'}),
				// key: 'safeQuantity',
				render: (h, { row, index }) => {
					return this.changeAllot(h, 'safeQuantity', row, index, { min: 0 });	
				},
			},
			// {
			// 	title: 'id',
			// 	key: 'accountId',
			// 	width: 0,
			// }, 
			]
		},

	},
	methods: {
		getLineName(id){
            let json = this.getNewDifferentAllProductList.filter(item=> {return item.value == id})[0] || {}
            return json.label
        },
		getTotal() {
			this.assignPercentTotal = this.formAllot.reduce((pre, next, index, array) => {
				return pre + next.assignPercent;
			}, 0)
		},
		cancel() {
			this.$router.push({ name: 'saTemplate' })
		},
		changeAllot(h, key, row, index, prop = {}) {
			return h('InputNumber', {
				key,
				props: {
					...prop,
					value: row[key]
				},
				on: {
					'input': (value) => {
						this.formAllot[index] = { ...this.formAllot[index], [key]: value };
						this.$emit('on-total')
					},
				}
			})
		},
		handleResponse(data = {}) {
			this.formData = data;
			this.formData.ruleName = data.stockVirtualGroupRuleEntity.name;
			this.formData.stockVirtualGroupRuleId = data.stockVirtualGroupRuleEntity.id;
			this.formAllot = data.stockTemplateItems || [];
			this.getTotal();
		},
		handeRequest() {
			const data = { ...this.formData, stockTemplateItems: this.formAllot, orgId: global.SYSID };
			if (this.type === 'edit') {
				data.id = this.id;
			};

			return data;
		},
		// getvsAccountData(val) {

		// },
		getvsData() {
			// this.getDetail()  页面闪了一下，开始有两个，对应找到id之后就只有一个了。这个方法暂时不打开
			const row = this.$refs.vsdata.getRowData();
			// console.log(row)
			this.formData = Object.assign(this.formData, { lineId: row.lineId, erpSku: row.erpSku, erpSkuReadonly: !!row.erpSku, stockVirtualGroupRuleId: row.id, ruleName: row.name })
			const data = row.stockVirtualGroupRuleAccountEntity || [];
			this.formAllot = data.map((item) => {
				// console.log(123)
				// console.log(item)
				let { assignPercent = 0, adjustValue = 0, safeQuantity = 0, accountFlag, accountId} = item;
				return { assignPercent, adjustValue, safeQuantity, accountFlag, accountId}
			});
			
		},
		// async getVslist(search = '', type = 'query') {
		// 	if (type === 'query') {
		// 		search = { CN_name: search, 'EQ_stockVirtualGroupEntity.status': 'ACTIVATE' }
		// 	} else {
		// 		search = { EQ_id: search, 'EQ_stockVirtualGroupEntity.status': 'ACTIVATE' }
		// 	}
		// 	HttpVsGroups({
		// 		page: 1,
		// 		rows: 10,
		// 		sidx: 'id',
		// 		sord: 'desc', search
		// 	}).then(res => {
		// 		this.vsrulelist = res.data.content.filter(item => {
		// 			return item.disabledAt == 0;
		// 		});
		// 	}, err => {
		// 	});
		// },
		async getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpSaTemplate({
				id: this.id
			}).then(res => {
				this.handleResponse(res.data);
				this.loading = false;
			}, err => {
				this.errorMessage(err.message);
				this.loading = false;
			});
		},
		async submit() {

			let valid = await this.$refs['form'].validate();
			if (!valid) return;
			this.judge = false;
			this.loading = true;
			this.formAllot.map(item=>{
				if(item.assignPercent==null || item.adjustValue==null || item.safeQuantity==null){
                    this.judge = true;
                }
			})
			if(this.judge == true){
				this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
				this.loading = false;
			}else{
				HttpUpdateSaTemplate(this.handeRequest()).then(res => {
					this.$Message.success(res.message);
					this.$router.push({ name: "saTemplate" });
					this.loading = false;
				}, err => {
					if(err.message == 'could not execute statement; SQL [n/a]; constraint [null]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement'){
						this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
						this.loading = false;
					}else{
						this.errorMessage(err.message);
						this.loading = false;
					}
				});
			}
		}

	},

};
</script>
